<div  class="linkerItem">
    <ng-container *ngFor="let item of linkerRouteItems; let last = last">
        <span (click)="routeClick(item,last)" class="Isname" >{{item?.name}}</span>
        <span *ngIf="!last" class="arrowicon"><i class="fa fa-long-arrow-right" aria-hidden="true"></i></span>  
    </ng-container>
</div>
<!-- <h1 class="mt-3 header-line">{{headingName}}</h1> -->